export const parseNumber = (value?: string | null) => {
  if (value === '' || value == null) {
    return value;
  }

  return String(value).replace(/[^0-9]/g, '');
};
